import { render, staticRenderFns } from "./DashboardOfertas.vue?vue&type=template&id=36b99d6c&scoped=true&lang=pug"
import script from "./DashboardOfertas.vue?vue&type=script&lang=js"
export * from "./DashboardOfertas.vue?vue&type=script&lang=js"
import style0 from "./DashboardOfertas.vue?vue&type=style&index=0&id=36b99d6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b99d6c",
  null
  
)

export default component.exports